import React from 'react';

const ImageSrc: React.FC = () => {
  return (
<div className="container text-center py-4">
      <h2 className="mb-4">Bildnachweise</h2>
      <ul className="text-left space-y-2 max-w-xl mx-auto">
        <li><strong>Kompass-Familienplanung</strong>: iStock-1137968176, Bildnachweis: LumiNola</li>
        <li><strong>Kompass-Schwangerschaft</strong>: iStock-1321727423, Bildnachweis: eclipse_images</li>
        <li><strong>Kompass-Rund um die Geburt</strong>: iStock-1321458978, Bildnachweis: Natalia Deviabina</li>
        <li><strong>Kompass-Baby ist da</strong>: iStock-92302885, Bildnachweis: damircudic</li>
        <li><strong>Elternschaft</strong>: iStock-1279843968, Bildnachweis: AnnaStills</li>
        <li><strong>Kompass-Beratung und Sozialrecht</strong>: iStock-1450936958, Bildnachweis: skynesher</li>
        <li><strong>Kompass-Kleinkind (1–3 Jahre)</strong>: iStock-500813356, Bildnachweis: FatCamera</li>
        <li><strong>Kompass-Kinderbetreuung</strong>: iStock-684062152, Bildnachweis: monkeybusinessimages</li>
        <li><strong>Kompass-Turbulente Zeiten</strong>: iStock-1359015956, Bildnachweis: SDI Productions</li>
      </ul>
    </div>
  );
};

export default ImageSrc;
